export default {"src":"/_next/static/media/BicycleIconCompare.f07af6e0.svg","height":43,"width":62,"blurWidth":0,"blurHeight":0};